import React, { Suspense } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { LoadingOverlay, SplashScreen } from 'components'

import BottomTabs from './partials/BottomTabs'

import styles from './styles.module.css'

const PageLayout = ({ children, match }) => {
  const isLoading = useSelector(({ common }) => common.loading)

  const location = useLocation()

  const hasBottomNavigation = () => {
    return (
      !location.pathname.includes('/products/single/') &&
      !location.pathname.includes('/onboarding') &&
      !location.pathname.includes('/callback') &&
      !location.pathname.includes('/feedback') &&
      !location.pathname.includes('/waiting-verification')&&
      !location.pathname.includes('/store-info')
    )
  }

  return (
    <div className={styles.container}>
      {isLoading && <LoadingOverlay />}
      <Suspense fallback={<SplashScreen />}>
        <div
          style={{
            paddingBottom: hasBottomNavigation() && 70,
          }}
          className={styles.content}
        >
          {children}
        </div>
      </Suspense>
      {hasBottomNavigation() && <BottomTabs />}
    </div>
  )
}

export default PageLayout
